import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = {
  class: "title"
};
const _hoisted_3 = {
  class: "sort-container"
};
const _hoisted_4 = {
  class: "filter-container"
};
import store from '@/store';
import { computed, nextTick, ref } from 'vue';
import _ from 'lodash';
import { ElSelect, ElRow, ElCol, ElButton, ElInput } from 'element-plus';
import { Sort, SortDown, SortUp } from '@element-plus/icons-vue';
export default {
  __name: 'DramaHeader',
  emits: ['updateFilter'],

  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const sortOptions = [{
      'id': 1,
      'desc': '预估难度',
      'value': 'difficulty'
    }, {
      'id': 2,
      'desc': '创作时间',
      'value': 'create_time'
    }, {
      'id': 3,
      'desc': '更新时间',
      'value': 'update_time'
    }];
    const selectSort = ref(null);
    const sortMode = ref(0);
    const selectNature = ref(null);
    const search = ref(null);
    const natureOptions = computed(() => {
      if (!worldOutlook.value) return [];
      return store.state.world_outlook_info[worldOutlook.value.id]?.drama_natures ?? [];
    });
    const sortIconList = [Sort, SortUp, SortDown];
    const sortIcon = computed(() => {
      return sortIconList[sortMode.value];
    });
    const worldOutlook = computed(() => store.state.world_outlook);

    const searchProps = () => {
      let filterInfo = { ...(selectNature.value && {
          'select_nature': selectNature.value
        }),
        ...(search.value && search.value.trim() !== '' && {
          'search': search.value
        })
      };

      if (selectSort.value && sortMode.value) {
        let sorter_key = selectSort.value;
        let sorter_reverse = 'ASC';
        if (sortMode.value === 2) sorter_reverse = 'DESC';
        filterInfo['select_sort'] = `${sorter_key};${sorter_reverse}`;
      } // console.log(JSON.stringify(filterInfo))


      nextTick(() => {
        emits('updateFilter', filterInfo);
      });
    };

    const onSelectFilterChange = _.debounce(searchProps, 300);

    const onInputFilterChange = _.debounce(searchProps, 300);

    const onSortChange = _.debounce(() => {
      if (selectSort.value && sortMode.value === 0) {
        sortMode.value = 1;
      } else if (!selectSort.value && sortMode.value !== 0) {
        sortMode.value = 0;
      }

      searchProps();
    }, 300);

    const onSortModeChange = _.debounce(() => {
      if (selectSort.value) {
        sortMode.value = sortMode.value === 1 ? 2 : 1;
      } else {// sortMode.value = (sortMode.value + 1) % 3
      }

      searchProps();
    }, 300);

    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(ElCol), {
        span: 24
      }, {
        default: _withCtx(() => [_createVNode(_unref(ElRow), {
          class: "find-container"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, _toDisplayString(worldOutlook.value ? `${worldOutlook.value.name} / ` : '') + "剧本列表 ", 1), _cache[3] || (_cache[3] = _createElementVNode("div", {
            style: {
              "display": "flex",
              "flex": "1"
            }
          }, null, -1)), _createElementVNode("div", _hoisted_3, [_createVNode(_unref(ElSelect), {
            modelValue: selectSort.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectSort.value = $event),
            "show-arrow": false,
            clearable: "",
            placeholder: "排序依据",
            "popper-class": "commonPopper",
            class: _normalizeClass(selectSort.value ? 'selected-selector sort-selector' : 'sort-selector'),
            onChange: _unref(onSortChange)
          }, {
            default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(sortOptions, item => {
              return _createVNode(_component_el_option, {
                key: item.id,
                label: item.desc,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 64))]),
            _: 1
          }, 8, ["modelValue", "class", "onChange"]), _createVNode(_unref(ElButton), {
            class: _normalizeClass([sortMode.value !== 0 ? 'is-active' : '']),
            icon: sortIcon.value,
            size: "small",
            onClick: _unref(onSortModeChange)
          }, null, 8, ["class", "icon", "onClick"])]), _createElementVNode("div", _hoisted_4, [_createVNode(_unref(ElSelect), {
            modelValue: selectNature.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => selectNature.value = $event),
            "show-arrow": false,
            clearable: "",
            placeholder: "风格筛选",
            "popper-class": "sort",
            onChange: _unref(onSelectFilterChange)
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(natureOptions.value, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.desc,
                value: item.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue", "onChange"]), _createVNode(_unref(ElInput), {
            modelValue: search.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => search.value = $event),
            maxlength: "16",
            placeholder: "查找模组",
            type: "text",
            onInput: _unref(onInputFilterChange)
          }, null, 8, ["modelValue", "onInput"])])]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }

};